import config from '@sp/config';

import {
  GET_CARS_DETAILS_FAIL,
  GET_CARS_DETAILS_SUCCESS,
  GET_PLAN_DETAILS_SUCCESS,
} from '../modules/admin/actions';

export default store => next => async action => {
  const result = next(action);

  if (action.type === GET_PLAN_DETAILS_SUCCESS) {
    try {
      const {
        admin: { planCarsList },
      } = store.getState();

      const carsDetailsPromises = planCarsList.map(({ VRN }) =>
        fetch(`${config.apiUrl}/car/vrl/${VRN}`),
      );
      const carsDetails = await Promise.all(carsDetailsPromises);

      store.dispatch({ type: GET_CARS_DETAILS_SUCCESS, payload: carsDetails });
    } catch (e) {
      store.dispatch({ type: GET_CARS_DETAILS_FAIL, payload: e });
    }
  }

  return result;
};
